/**
 * Created by jayed.talukder on 9/13/2018.
 */
import {Action} from '@ngrx/store';
import {RelativePath} from '@shared/constants/RelativePath';
import {FieldDefinition} from '@shared/models/field-definition';
import {PagedResponse} from '@shared/models/paged-response-model';
import {EntitySetting} from '../../../models/entity-setting.model';
import {PaymentStream} from '../../../models/payment-stream.model';
import {
  CreateTransactionsBetweenMyCountriesCommand, DeleteAllTransactionCommand, ResetTransactionsFromProjectSettingsCommand,
  TransactionAddCommand, TransactionDeleteCommand, TransactionImportCommand
} from '../../commands/transaction.commands';
import {PaymentStreamSetting} from '../../../models/payment-stream-setting.model';

export const FETCH_ALL_PAYING_ENTITIES = '[Transaction] FETCH_ALL_PAYING_ENTITIES';
export const FETCH_ALL_RECEIVING_ENTITIES = '[Transaction] FETCH_ALL_RECEIVING_ENTITIES';
export const FETCH_ALL_STREAMS = '[Transaction] FETCH_ALL_STREAMS';
export const SET_PAYING_ENTITIES = '[Transaction] SET_PAYING_ENTITIES';
export const FETCH_PAYING_ENTITIES_FAILED = '[Transaction] FETCH_PAYING_ENTITIES_FAILED';
export const FETCH_ALL_PAYING_ENTITIES_FAILED = '[Transaction] FETCH_ALL_PAYING_ENTITIES_FAILED';
export const FETCH_ALL_RECEIVING_ENTITIES_FAILED = '[Transaction] FETCH_ALL_RECEIVING_ENTITIES_FAILED';
export const FETCH_ALL_STREAMS_FAILED = '[Transaction] FETCH_ALL_STREAMS_FAILED';
export const FETCH_RECEIVING_ENTITIES = '[Transaction] FETCH_RECEIVING_ENTITIES';
export const SET_RECEIVING_ENTITIES = '[Transaction] SET_RECEIVING_ENTITIES';
export const FETCH_RECEIVING_ENTITIES_FAILED = '[Transaction] FETCH_RECEIVING_ENTITIES_FAILED';
export const GET_STREAMS = '[Transaction] GET_STREAMS';
export const GET_STREAMS_SUCCESS = '[Transaction] GET_STREAMS_SUCCESS';
export const GET_STREAMS_FAILED = '[Transaction] GET_STREAMS_FAILED';

export const ADD_TRANSACTION = '[Transaction] ADD_TRANSACTION';
export const ADD_TRANSACTION_SUCCESS = '[Transaction] ADD_TRANSACTION_SUCCESS';
export const ADD_TRANSACTION_FAILED = '[Transaction] ADD_TRANSACTION_FAILED';
export const DELETE_TRANSACTION = '[Transaction] DELETE_TRANSACTION';
export const DELETE_TRANSACTION_SUCCESS = '[Transaction] DELETE_TRANSACTION_SUCCESS';
export const DELETE_TRANSACTION_FAILED = '[Transaction] DELETE_TRANSACTION_FAILED';
export const GET_TRANSACTIONS = '[Transaction] GET_TRANSACTIONS';
export const GET_TRANSACTIONS_SUCCESS = '[Transaction] GET_TRANSACTIONS_SUCCESS';
export const GET_TRANSACTIONS_FAILED = '[Transaction] GET_TRANSACTIONS_FAILED';

export const GET_TRANSACTION_FIELD_DEFINATIONS = '[Transaction] GET_TRANSACTION_FIELD_DEFINATIONS';
export const GET_TRANSACTION_FIELD_DEFINATIONS_SUCCESS = '[Transaction] GET_TRANSACTION_FIELD_DEFINATIONS_SUCCESS';
export const GET_TRANSACTION_FIELD_DEFINATIONS_FAILED = '[Transaction] GET_TRANSACTION_FIELD_DEFINATIONS_FAILED';


export const TRANSACTION_UPLOAD_SOURCE_FILE = '[Transaction] TRANSACTION_UPLOAD_SOURCE_FILE';
export const TRANSACTION_UPLOAD_SOURCE_FILE_SUCCESS = '[Transaction] TRANSACTION_UPLOAD_SOURCE_FILE_SUCCESS';
export const TRANSACTION_UPLOAD_SOURCE_FILE_FAILED = '[Transaction] TRANSACTION_UPLOAD_SOURCE_FILE_FAILED';

export const TRANSACTION_IMPORT = '[Transaction] TRANSACTION_IMPORT';
export const TRANSACTION_IMPORT_SUCCESS = '[Transaction] TRANSACTION_IMPORT_SUCCESS';
export const TRANSACTION_IMPORT_FAILED = '[Transaction] TRANSACTION_IMPORT_FAILED';

export const TRANSACTION_DATA_TEMPLATE_DOWNLOAD = '[Transaction] TRANSACTION_DATA_TEMPLATE_DOWNLOAD';
export const TRANSACTION_DATA_TEMPLATE_DOWNLOAD_SUCCESS = '[Transaction] TRANSACTION_DATA_TEMPLATE_DOWNLOAD_SUCCESS';
export const TRANSACTION_DATA_TEMPLATE_DOWNLOAD_FAILED = '[Transaction] TRANSACTION_DATA_TEMPLATE_DOWNLOAD_FAILED';

export const GET_RECEIVING_ENTITIES_STREAMS = '[Transaction] GET_RECEIVING_ENTITIES_STREAMS';

export const CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES = '[Transaction] CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES';
export const CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES_SUCCESS = '[Transaction] CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES_SUCCESS';
export const CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES_FAILED = '[Transaction] CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES_FAILED';

export const DELETE_ALL_TRANSACTION = '[Transaction] DELETE_ALL_TRANSACTION';
export const DELETE_ALL_TRANSACTION_SUCCESS = '[Transaction] DELETE_ALL_TRANSACTION_SUCCESS';
export const DELETE_ALL_TRANSACTION_FAILED = '[Transaction] DELETE_ALL_TRANSACTION_FAILED';

export const RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS = '[Transaction] RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS';
export const RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS_SUCCESS = '[Transaction] RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS_SUCCESS';
export const RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS_FAILED = '[Transaction] RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS_FAILED';


export class FetchAllPayingEntitiesAction implements Action {
  readonly type = FETCH_ALL_PAYING_ENTITIES;

  constructor() {
  }
}

export class FetchAllReceivingEntitiesAction implements Action {
  readonly type = FETCH_ALL_RECEIVING_ENTITIES;

  constructor() {
  }
}

export class FetchAllStreamsAction implements Action {
  readonly type = FETCH_ALL_STREAMS;

  constructor() {
  }
}

export class SetPayingEntitiesAction implements Action {
  readonly type = SET_PAYING_ENTITIES;

  constructor(public payload: EntitySetting[]) {
  }
}

export class FetchAllPayingEntitiesActionFailed implements Action {
  readonly type = FETCH_ALL_PAYING_ENTITIES_FAILED;

  constructor(public payload: any) {
  }
}

export class FetchAllReceivingEntitiesActionFailed implements Action {
  readonly type = FETCH_ALL_RECEIVING_ENTITIES_FAILED;

  constructor(public payload: any) {
  }
}

export class FetchAllStreamsActionFailed implements Action {
  readonly type = FETCH_ALL_STREAMS_FAILED;

  constructor(public payload: any) {
  }
}

export class FetchReceivingEntitiesAction implements Action {
  readonly type = FETCH_RECEIVING_ENTITIES;

  constructor(public payload: string) {
  }
}

export class SetReceivingEntitiesAction implements Action {
  readonly type = SET_RECEIVING_ENTITIES;

  constructor(public payload: EntitySetting[]) {
  }
}

export class FetchReceivingEntitiesActionFailed implements Action {
  readonly type = FETCH_RECEIVING_ENTITIES_FAILED;

  constructor(public payload: any) {
  }
}

export class GetStreamsAction implements Action {
  readonly type = GET_STREAMS;

  constructor(public payingEntity: string, public receivingEntity: string) {
  }
}

export class GetStreamsActionSuccess implements Action {
  readonly type = GET_STREAMS_SUCCESS;

  constructor(public payload: PaymentStreamSetting[]) {
  }
}

export class GetStreamsActionFailed implements Action {
  readonly type = GET_STREAMS_FAILED;

  constructor(public payload: any) {
  }
}

export class TransactionAddAction implements Action {
  readonly type = ADD_TRANSACTION;

  constructor(public command: TransactionAddCommand, public sourceType: string) {
  }
}

export class TransactionAddActionSuccess implements Action {
  readonly type = ADD_TRANSACTION_SUCCESS;

  constructor(public payload: any) {
  }
}

export class TransactionAddActionFailed implements Action {
  readonly type = ADD_TRANSACTION_FAILED;

  constructor(public payload: any) {
  }
}


export class TransactionDeleteAction implements Action {
  readonly type = DELETE_TRANSACTION;

  constructor(public command: TransactionDeleteCommand, public sourceType: string) {
  }
}

export class TransactionDeleteActionSuccess implements Action {
  readonly type = DELETE_TRANSACTION_SUCCESS;

  constructor(public payload: any) {
  }
}

export class TransactionDeleteActionFailed implements Action {
  readonly type = DELETE_TRANSACTION_FAILED;

  constructor(public payload: any) {
  }
}

export class GetTransactionsAction implements Action {
  readonly type = GET_TRANSACTIONS;

  constructor(public pageNo?: number, public pageSize?: number) {
  }
}
export class GetTransactionsSuccessAction implements Action {
  readonly type = GET_TRANSACTIONS_SUCCESS;

  constructor(public pagedResponse: PagedResponse) {
  }
}
export class GetTransactionsFailedAction implements Action {
  readonly type = GET_TRANSACTIONS_FAILED;

  constructor(public err: any) {
  }
}

export class GetTransactionFieldDefinationsAction implements Action {
  readonly type = GET_TRANSACTION_FIELD_DEFINATIONS;

  constructor(public apiKey: string, public query: any) {
  }
}
export class GetTransactionFieldDefinationsSuccessAction implements Action {
  readonly type = GET_TRANSACTION_FIELD_DEFINATIONS_SUCCESS;

  constructor(public payload: FieldDefinition[]) {
  }
}
export class GetTransactionFieldDefinationsFailedAction implements Action {
  readonly type = GET_TRANSACTION_FIELD_DEFINATIONS_FAILED;

  constructor(public err: any) {
  }
}

export class TransactionUploadSourceFileAction implements Action {
  readonly type = TRANSACTION_UPLOAD_SOURCE_FILE;
  public path: string;
  public overwrite: boolean;

  constructor(public file: File, public replaceExistingSelection: boolean, public sourceType: string) {
    this.path = RelativePath.Transaction;
    this.overwrite = true;
  }
}

export class TransactionUploadSourceFileSuccessAction implements Action {
  readonly type = TRANSACTION_UPLOAD_SOURCE_FILE_SUCCESS;

  constructor(public transactionUploadSourceFileSuccessPayload: any) {
  }
}

export class TransactionUploadSourceFileFailedAction implements Action {
  readonly type = TRANSACTION_UPLOAD_SOURCE_FILE_FAILED;

  constructor(public error: any) {
  }
}

export class TransactionImportAction implements Action {
  readonly type = TRANSACTION_IMPORT;

  constructor(public command: TransactionImportCommand) {
  }
}


export class TransactionImportFailAction implements Action {
  readonly type = TRANSACTION_IMPORT_FAILED;

  constructor(public err: any) { // TODO: don't use any.
  }
}

export class TransactionImportSuccessAction implements Action {
  readonly type = TRANSACTION_IMPORT_SUCCESS;

  constructor(public transactionImportSuccessPayload: any) { // TODO: don't use any.
    console.log('TransactionImportSuccess');
  }
}

export class TransactionDataTemplateDownloadAction implements Action {
  readonly type = TRANSACTION_DATA_TEMPLATE_DOWNLOAD;

  constructor(public fileName: string) {
  }
}

export class TransactionDataTemplateDownloadSuccessAction implements Action {
  readonly type = TRANSACTION_DATA_TEMPLATE_DOWNLOAD_SUCCESS;

  constructor() {
  }
}

export class TransactionDataTemplateDownloadFailedAction implements Action {
  readonly type = TRANSACTION_DATA_TEMPLATE_DOWNLOAD_FAILED;

  constructor(public err: any) {
  }
}

export class GetReceivingEntitiesStreamsAction implements Action {
  readonly type = GET_RECEIVING_ENTITIES_STREAMS;

  constructor(public payingEntityId: string, public receivingEntityId: string) {
  }
}

export class CreateTransactionsBetweenMyCountriesAction implements Action {
  readonly type = CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES;

  constructor(public command: CreateTransactionsBetweenMyCountriesCommand, public sourceType: string) {
  }
}

export class CreateTransactionsBetweenMyCountriesSuccessAction implements Action {
  readonly type = CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES_SUCCESS;

  constructor(public payload: any) {
  }
}

export class CreateTransactionsBetweenMyCountriesFailedAction implements Action {
  readonly type = CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES_FAILED;

  constructor(public err: any) {
  }
}


export class DeleteAllTransactionsAction implements Action {
  readonly type = DELETE_ALL_TRANSACTION;

  constructor(public command: DeleteAllTransactionCommand, public sourceType: string) {
  }
}

export class DeleteAllTransactionsSuccessAction implements Action {
  readonly type = DELETE_ALL_TRANSACTION_SUCCESS;

  constructor(public payload: any) {
  }
}

export class DeleteAllTransactionsFailedAction implements Action {
  readonly type = DELETE_ALL_TRANSACTION_FAILED;

  constructor(public err: any) {
  }
}

export class ResetTransactionsFromProjectSettingsAction implements Action {
  readonly type = RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS;

  constructor(public command: ResetTransactionsFromProjectSettingsCommand, public sourceType: string) {
  }
}

export class ResetTransactionsFromProjectSettingsSuccessAction implements Action {
  readonly type = RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class ResetTransactionsFromProjectSettingsFailedAction implements Action {
  readonly type = RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS_FAILED;

  constructor(public err: any) {
  }
}


export type TransactionActions =
  FetchAllPayingEntitiesAction
  | FetchAllReceivingEntitiesAction
  | FetchAllStreamsAction
  | SetPayingEntitiesAction
  | FetchAllPayingEntitiesActionFailed
  | FetchAllReceivingEntitiesActionFailed
  | FetchAllStreamsActionFailed
  | FetchReceivingEntitiesAction
  | SetReceivingEntitiesAction
  | FetchReceivingEntitiesActionFailed
  | GetStreamsAction
  | GetStreamsActionSuccess
  | GetStreamsActionFailed
  | TransactionAddAction
  | TransactionAddActionSuccess
  | TransactionAddActionFailed
  | TransactionDeleteAction
  | TransactionDeleteActionSuccess
  | TransactionDeleteActionFailed
  | TransactionUploadSourceFileAction
  | TransactionUploadSourceFileSuccessAction
  | TransactionUploadSourceFileFailedAction
  | TransactionImportAction
  | TransactionImportFailAction
  | TransactionImportSuccessAction
  | TransactionDataTemplateDownloadAction
  | TransactionDataTemplateDownloadSuccessAction
  | TransactionDataTemplateDownloadFailedAction
  | GetTransactionsAction
  | GetTransactionsSuccessAction
  | GetTransactionsFailedAction
  | GetTransactionFieldDefinationsAction
  | GetTransactionFieldDefinationsSuccessAction
  | GetTransactionFieldDefinationsFailedAction
  | GetReceivingEntitiesStreamsAction
  | CreateTransactionsBetweenMyCountriesAction
  | CreateTransactionsBetweenMyCountriesSuccessAction
  | CreateTransactionsBetweenMyCountriesFailedAction
  | DeleteAllTransactionsAction
  | DeleteAllTransactionsFailedAction
  | DeleteAllTransactionsSuccessAction
  | ResetTransactionsFromProjectSettingsAction
  | ResetTransactionsFromProjectSettingsSuccessAction
  | ResetTransactionsFromProjectSettingsFailedAction;
